module.exports = "images/nav-desktops-2023-02-16.jpg";